const DEFAULT_API_VERSION = '2026-04';
const DEFAULT_COUNTRY = 'AU';
const DEFAULT_LANGUAGE = 'EN';
const DEFAULT_LOCALE_BY_COUNTRY = {
  AU: 'en-AU',
  NZ: 'en-NZ',
  GB: 'en-GB',
  US: 'en-US',
};

const IMPRINT_SIZE_CHART_LOGO = 'https://cdn.shopify.com/s/files/1/0252/8378/8880/files/IM_logo-90K_1000_480x480.png?v=1593242148';
const IMPRINT_SIZE_CHART_IMAGE = 'https://cdn.shopify.com/s/files/1/0252/8378/8880/files/5050fit_9312173f-6e56-45a5-be26-f70ac1e63893_240x240.png?v=1572941377';
const IMPRINT_MERCH_LOGO = 'https://cdn.shopify.com/s/files/1/1003/3895/8701/files/imprint_merch.svg?v=1780619028';
const IMPRINT_SIZE_CHART_GROUPS = [
  {
    brand: 'AS Colour',
    charts: [
      { name: 'Block Tee', sizes: ['S', 'M', 'L', 'XL', '2XL'], rows: [['Body Width (cm)', '46', '51', '56', '61', '66'], ['Body Length (cm)', '71', '74', '77', '80', '83']] },
      { name: 'Staple Tee', sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL'], rows: [['Body Width (cm)', '47', '52', '57', '61', '64', '68'], ['Body Length (cm)', '71', '75', '79', '82', '84', '85']] },
      { name: 'Stone Wash Heavy', sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL'], rows: [['Body Width (cm)', '51', '55', '59', '63', '67', '71'], ['Body Length (cm)', '71.5', '75', '78.5', '82', '85.5', '87.5']] },
      { name: 'Long Sleeve', sizes: ['S', 'M', 'L', 'XL', '2XL'], rows: [['Body Width (cm)', '49', '53', '57', '61', '65'], ['Body Length (cm)', '73', '76', '78', '81', '83']] },
      { name: 'Barnard Tank', sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'], rows: [['Body Width (cm)', '45', '48', '51', '54', '57', '60'], ['Body Length (cm)', '69', '72', '75', '78', '81', '84']] },
      { name: 'Lowdown Singlet', sizes: ['S', 'M', 'L', 'XL', '2XL'], rows: [['Body Width (cm)', '46', '49', '52', '55', '58'], ['Body Length (cm)', '74', '77', '80', '83', '86']] },
      { name: 'Tall Tee', sizes: ['S', 'M', 'L', 'XL', '2XL'], rows: [['Body Width (cm)', '48', '52', '57', '61', '66'], ['Body Length (cm)', '82', '85', '89', '92', '94']] },
      { name: 'Ringer Tee', sizes: ['S', 'M', 'L', 'XL', '2XL'], rows: [['Body Width (cm)', '47', '52', '57', '61', '64'], ['Body Length (cm)', '71', '75', '79', '82', '84']] },
      { name: 'Wafer Tee', sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'], rows: [['Body Width (cm)', '42', '44', '47', '49', '53', '57'], ['Body Length (cm)', '68', '69', '70', '71', '72', '73']] },
      { name: 'Organic Maple Tee', sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'], rows: [['Body Width (cm)', '46', '48', '51', '53', '56', '58'], ['Body Length (cm)', '64', '65', '66', '67', '68', '69']] },
      { name: "Women's Crop", sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'], rows: [['Body Width (cm)', '47.5', '50', '52.5', '55', '57.5', '60'], ['Body Length (cm)', '44', '45', '46.5', '47.5', '48.5', '49.5']] },
      { name: 'Tulip Singlet', sizes: ['XS', 'S', 'M', 'L', 'XL'], rows: [['Body Width (cm)', '44', '47', '49', '52', '54'], ['Body Length (cm)', '70', '72', '74', '76', '78']] },
    ],
  },
  {
    brand: 'Gildan',
    charts: [
      { name: 'Adult T-Shirt', sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'], rows: [['Body Width (cm)', '46', '51', '56', '61', '66', '71', '76', '81'], ['Body Length (cm)', '71', '74', '76', '79', '81', '84', '86', '89']] },
      { name: 'Adult Long Sleeve', sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'], rows: [['Body Width (cm)', '46', '51', '56', '61', '66', '71', '76', '81'], ['Body Length (cm)', '71', '74', '76', '79', '81', '84', '86', '89']] },
      { name: 'Adult Tank Top', sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL'], rows: [['Body Width (cm)', '46', '51', '56', '61', '66', '71'], ['Body Length (cm)', '71', '74', '76', '79', '81', '84']] },
      { name: 'Ladies T-Shirt', sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL'], rows: [['Body Width (cm)', '41', '43', '47', '50', '56', '60'], ['Body Length (cm)', '64', '67', '69', '71', '72', '74']] },
      { name: 'Adult Ringer Tee', sizes: ['S', 'M', 'L', 'XL', '2XL'], rows: [['Body Width (cm)', '46', '51', '56', '61', '66'], ['Body Length (cm)', '71', '74', '76', '79', '81']] },
      { name: 'Adult 3/4 Raglan T-Shirt', sizes: ['S', 'M', 'L', 'XL', '2XL'], rows: [['Body Width (cm)', '46', '51', '56', '61', '66'], ['Body Length (cm)', '71', '74', '76', '79', '81']] },
    ],
  },
];

const CART_FIELDS = `
  id
  checkoutUrl
  totalQuantity
  cost {
    subtotalAmount {
      amount
      currencyCode
    }
    totalAmount {
      amount
      currencyCode
    }
  }
  lines(first: 50) {
    nodes {
      id
      quantity
      cost {
        amountPerQuantity {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }
      }
      merchandise {
        ... on ProductVariant {
          id
          title
          availableForSale
          image {
            url
            altText
            width
            height
          }
          selectedOptions {
            name
            value
          }
          product {
            id
            title
            handle
          }
        }
      }
    }
  }
`;

const CART_QUERY = `
  query PartnerCart($cartId: ID!) {
    cart(id: $cartId) {
      ${CART_FIELDS}
    }
  }
`;

const CART_CREATE_MUTATION = `
  mutation PartnerCartCreate($lines: [CartLineInput!]!, $country: CountryCode!) {
    cartCreate(input: { lines: $lines, buyerIdentity: { countryCode: $country } }) {
      cart {
        ${CART_FIELDS}
      }
      userErrors {
        field
        message
      }
    }
  }
`;

const CART_LINES_ADD_MUTATION = `
  mutation PartnerCartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        ${CART_FIELDS}
      }
      userErrors {
        field
        message
      }
    }
  }
`;

const CART_LINES_UPDATE_MUTATION = `
  mutation PartnerCartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        ${CART_FIELDS}
      }
      userErrors {
        field
        message
      }
    }
  }
`;

const CART_LINES_REMOVE_MUTATION = `
  mutation PartnerCartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        ${CART_FIELDS}
      }
      userErrors {
        field
        message
      }
    }
  }
`;

function buildCollectionQuery(country, language, identifierType) {
  const safeCountry = /^[A-Z]{2}$/.test(country) ? country : DEFAULT_COUNTRY;
  const safeLanguage = /^[A-Z]{2}$/.test(language) ? language : DEFAULT_LANGUAGE;
  const variableDefinition = identifierType === 'id' ? '$id: ID!, $first: Int!' : '$handle: String!, $first: Int!';
  const collectionArgument = identifierType === 'id' ? 'id: $id' : 'handle: $handle';

  return `
    query PartnerCollection(${variableDefinition}) @inContext(country: ${safeCountry}, language: ${safeLanguage}) {
      collection(${collectionArgument}) {
        id
        title
        handle
        products(first: $first) {
          nodes {
            id
            title
            handle
            onlineStoreUrl
            availableForSale
            productType
            vendor
            tags
            descriptionHtml
            featuredImage {
              url
              altText
              width
              height
            }
            priceRange {
              minVariantPrice {
                amount
                currencyCode
              }
              maxVariantPrice {
                amount
                currencyCode
              }
            }
            compareAtPriceRange {
              minVariantPrice {
                amount
                currencyCode
              }
              maxVariantPrice {
                amount
                currencyCode
              }
            }
            images(first: 2) {
              nodes {
                url
                altText
                width
                height
              }
            }
            options {
              name
              values
            }
            variants(first: 100) {
              nodes {
                id
                title
                availableForSale
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
                image {
                  url
                  altText
                  width
                  height
                }
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
    }
  `;
}

function buildProductSearchQuery(country, language) {
  const safeCountry = /^[A-Z]{2}$/.test(country) ? country : DEFAULT_COUNTRY;
  const safeLanguage = /^[A-Z]{2}$/.test(language) ? language : DEFAULT_LANGUAGE;

  return `
    query PartnerProductSearch($query: String!, $first: Int!) @inContext(country: ${safeCountry}, language: ${safeLanguage}) {
      products(first: $first, query: $query) {
        nodes {
          id
          title
          handle
          onlineStoreUrl
          availableForSale
          productType
          vendor
          tags
          descriptionHtml
          featuredImage {
            url
            altText
            width
            height
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          compareAtPriceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          images(first: 2) {
            nodes {
              url
              altText
              width
              height
            }
          }
          options {
            name
            values
          }
          variants(first: 100) {
            nodes {
              id
              title
              availableForSale
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
              image {
                url
                altText
                width
                height
              }
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    }
  `;
}

function buildProductQuery(country, language) {
  const safeCountry = /^[A-Z]{2}$/.test(country) ? country : DEFAULT_COUNTRY;
  const safeLanguage = /^[A-Z]{2}$/.test(language) ? language : DEFAULT_LANGUAGE;

  return `
    query PartnerProduct($handle: String!) @inContext(country: ${safeCountry}, language: ${safeLanguage}) {
      product(handle: $handle) {
        id
        title
        handle
        onlineStoreUrl
        availableForSale
        descriptionHtml
        featuredImage {
          url
          altText
          width
          height
        }
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }
        compareAtPriceRange {
          minVariantPrice {
            amount
            currencyCode
          }
          maxVariantPrice {
            amount
            currencyCode
          }
        }
        images(first: 20) {
          nodes {
            url
            altText
            width
            height
          }
        }
        options {
          name
          values
        }
        variants(first: 100) {
          nodes {
            id
            title
            availableForSale
            price {
              amount
              currencyCode
            }
            compareAtPrice {
              amount
              currencyCode
            }
            image {
              url
              altText
              width
              height
            }
            selectedOptions {
              name
              value
            }
          }
        }
      }
    }
  `;
}

function parseJsonScript(element) {
  if (!(element instanceof HTMLScriptElement)) return null;

  try {
    return JSON.parse(element.textContent || '{}');
  } catch (error) {
    console.error('Partner merch JSON parse error:', error);
    return null;
  }
}

function escapeHtml(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

function renderImprintSizeChartTable(chart) {
  const headingCells = ['Size', ...chart.sizes].map((value) => `<th scope="col">${escapeHtml(value)}</th>`).join('');
  const bodyRows = chart.rows.map(([label, ...values]) => `
    <tr>
      <th scope="row">${escapeHtml(label)}</th>
      ${values.map((value) => `<td>${escapeHtml(value)}</td>`).join('')}
    </tr>
  `).join('');

  return `
    <section class="partner-merch-size-chart__table-group">
      <h5>${escapeHtml(chart.name)}</h5>
      <div class="partner-merch-size-chart__table-wrap">
        <table>
          <thead>
            <tr>${headingCells}</tr>
          </thead>
          <tbody>${bodyRows}</tbody>
        </table>
      </div>
    </section>
  `;
}

function renderImprintSizeChart() {
  return `
    <div class="partner-merch-size-chart">
      <img class="partner-merch-size-chart__logo" src="${escapeHtml(IMPRINT_SIZE_CHART_LOGO)}" alt="Imprint Merch" width="119" height="47" loading="lazy">
      <p>Garment sizing may vary. Please check official brands website for up to date sizing.</p>
      <img class="partner-merch-size-chart__guide" src="${escapeHtml(IMPRINT_SIZE_CHART_IMAGE)}" alt="AS Colour size guide" width="240" height="240" loading="lazy">
      ${IMPRINT_SIZE_CHART_GROUPS.map((group) => `
        <section class="partner-merch-size-chart__brand">
          <h4>${escapeHtml(group.brand)}</h4>
          ${group.charts.map(renderImprintSizeChartTable).join('')}
        </section>
      `).join('')}
    </div>
  `;
}

function toLegacyCollectionGid(identifier) {
  return /^\d+$/.test(identifier) ? `gid://shopify/Collection/${identifier}` : identifier;
}

function normalizeCollectionIdentifier(identifier) {
  const normalized = String(identifier || '').trim();
  if (!normalized) return null;

  if (normalized.startsWith('gid://shopify/Collection/')) {
    return { type: 'id', value: normalized };
  }

  if (/^\d+$/.test(normalized)) {
    return { type: 'id', value: toLegacyCollectionGid(normalized) };
  }

  return { type: 'handle', value: normalized };
}

function isDefaultTitle(value) {
  return String(value || '').trim().toLowerCase() === 'default title';
}

function normalizeProduct(product) {
  if (Array.isArray(product.variants) && Array.isArray(product.images)) {
    return product;
  }

  const variants = (product.variants?.nodes || []).map((variant) => ({
    ...variant,
    selectedOptions: variant.selectedOptions || [],
    image: variant.image || product.featuredImage || null,
  }));

  return {
    ...product,
    featuredImage: product.featuredImage || variants[0]?.image || null,
    images: product.images?.nodes || [],
    variants,
  };
}

function normalizePublicUrl(value, origin = '') {
  const url = String(value || '').trim();
  if (!url) return '';
  if (url.startsWith('//')) return `https:${url}`;
  if (url.startsWith('/')) return origin ? `${origin}${url}` : url;
  return url;
}

function normalizePublicImage(image, fallbackAlt = '', origin = '') {
  if (!image) return null;

  if (typeof image === 'string') {
    const url = normalizePublicUrl(image, origin);
    return url ? { url, altText: fallbackAlt, width: 1200, height: 1200 } : null;
  }

  const url = normalizePublicUrl(image.src || image.url, origin);
  if (!url) return null;

  return {
    url,
    altText: image.alt || image.altText || fallbackAlt,
    width: image.width || 1200,
    height: image.height || 1200,
  };
}

function normalizePublicMoney(amount, currencyCode = 'AUD') {
  if (amount === null || amount === undefined || amount === '') return null;

  const numericAmount = Number(amount);
  if (!Number.isFinite(numericAmount)) return null;

  const normalizedAmount = typeof amount === 'number' ? numericAmount / 100 : numericAmount;

  return {
    amount: normalizedAmount.toFixed(2),
    currencyCode,
  };
}

function normalizePublicProduct(product, currencyCode = 'AUD', origin = '') {
  const images = (Array.isArray(product.images) ? product.images : [])
    .map((image) => normalizePublicImage(image, product.title, origin))
    .filter(Boolean);
  const featuredImage = normalizePublicImage(product.featured_image || product.image, product.title, origin) || images[0] || null;
  const optionList = Array.isArray(product.options)
    ? product.options
    : product.options
      ? [product.options]
      : [];
  const options = optionList.map((option, index) => {
    const optionName = typeof option === 'string' ? option : option?.name || `Option ${index + 1}`;
    const explicitValues = Array.isArray(option?.values) ? option.values : [];
    const variantValues = (Array.isArray(product.variants) ? product.variants : [])
      .map((variant) => variant[`option${index + 1}`] || (Array.isArray(variant.options) ? variant.options[index] : ''))
      .filter(Boolean);

    return {
      name: optionName,
      values: explicitValues.length ? explicitValues : [...new Set(variantValues)],
    };
  });
  const variants = (Array.isArray(product.variants) ? product.variants : []).map((variant) => {
    const selectedOptions = options.map((option, index) => ({
      name: option.name,
      value: variant[`option${index + 1}`] || (Array.isArray(variant.options) ? variant.options[index] : ''),
    })).filter((option) => option.value);
    const image = normalizePublicImage(variant.featured_image, product.title, origin) || featuredImage;

    return {
      id: variant.id ? `gid://shopify/ProductVariant/${variant.id}` : '',
      publicVariantId: variant.id ? String(variant.id) : '',
      title: variant.title || '',
      availableForSale: variant.available !== false,
      price: normalizePublicMoney(variant.price, currencyCode),
      compareAtPrice: normalizePublicMoney(variant.compare_at_price, currencyCode),
      image,
      selectedOptions,
    };
  });
  const prices = variants.map((variant) => Number(variant.price?.amount)).filter(Number.isFinite);
  const compareAtPrices = variants.map((variant) => Number(variant.compareAtPrice?.amount)).filter(Number.isFinite);
  const minPrice = prices.length ? Math.min(...prices).toFixed(2) : '0.00';
  const maxPrice = prices.length ? Math.max(...prices).toFixed(2) : minPrice;
  const minCompareAtPrice = compareAtPrices.length ? Math.min(...compareAtPrices).toFixed(2) : null;
  const maxCompareAtPrice = compareAtPrices.length ? Math.max(...compareAtPrices).toFixed(2) : minCompareAtPrice;
  const productUrl = product.url || (product.handle ? `/products/${product.handle}` : '');

  return {
    id: product.id ? `gid://shopify/Product/${product.id}` : product.handle || '',
    title: product.title || '',
    handle: product.handle || '',
    onlineStoreUrl: normalizePublicUrl(productUrl, origin) || null,
    availableForSale: variants.some((variant) => variant.availableForSale),
    productType: product.product_type || product.type || '',
    vendor: product.vendor || '',
    tags: Array.isArray(product.tags) ? product.tags : [],
    descriptionHtml: product.body_html || product.description || '',
    featuredImage,
    priceRange: {
      minVariantPrice: normalizePublicMoney(minPrice, currencyCode),
      maxVariantPrice: normalizePublicMoney(maxPrice, currencyCode),
    },
    compareAtPriceRange: {
      minVariantPrice: minCompareAtPrice ? normalizePublicMoney(minCompareAtPrice, currencyCode) : null,
      maxVariantPrice: maxCompareAtPrice ? normalizePublicMoney(maxCompareAtPrice, currencyCode) : null,
    },
    images,
    options,
    variants,
    source: 'public_online_store_json',
  };
}

function normalizeCart(cart) {
  const lines = (cart.lines?.nodes || []).map((line) => ({
    ...line,
    merchandise: line.merchandise || null,
  }));

  return {
    ...cart,
    lines,
  };
}

function productIsArchive(product) {
  const searchText = `${product?.title || ''} ${product?.handle || ''}`.toLowerCase();
  return searchText.includes('archive');
}

function productSortRank(product) {
  const searchText = `${product?.title || ''} ${product?.handle || ''}`.toLowerCase();

  if (/\bcrop\b/.test(searchText)) return 2;
  if (/\bjersey\b/.test(searchText)) return 1;
  if (/\b(jacket|puffer|coat|windbreaker)\b/.test(searchText)) return 4;
  if (/\bhoodie\b/.test(searchText)) return 3;
  if (/\b(2?lp|vinyl|record)\b/.test(searchText)) return 5;
  if (/\bcd\b|compact disc/.test(searchText)) return 6;
  if (/\b(t-?shirt|tee|shirt|longsleeve|long sleeve|singlet|tank)\b/.test(searchText)) return 0;

  return 7;
}

function sortPartnerProducts(products) {
  return products
    .map((product, index) => ({
      product,
      index,
      archive: productIsArchive(product),
      rank: productSortRank(product),
    }))
    .sort((a, b) => (
      Number(a.archive) - Number(b.archive)
      || a.rank - b.rank
      || a.index - b.index
    ))
    .map((item) => item.product);
}

function shuffleProducts(products) {
  return products
    .map((product) => ({ product, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map((item) => item.product);
}

function optionMapFromVariant(variant) {
  return Object.fromEntries((variant?.selectedOptions || []).map((option) => [option.name, option.value]));
}

function productHasVariantChoices(product) {
  if (product.variants.length <= 1) return false;
  if (product.options.length !== 1) return true;

  const [option] = product.options;
  return !(option && isDefaultTitle(option.name) && option.values.length === 1 && isDefaultTitle(option.values[0]));
}

function getFirstAvailableVariant(product) {
  return product.variants.find((variant) => variant.availableForSale) || product.variants[0] || null;
}

function selectedVariantTitle(variant) {
  if (!variant) return '';
  if (!variant.title || isDefaultTitle(variant.title)) return '';
  return variant.title;
}

function selectedVariantLabel(variant) {
  if (!variant) return '';

  const optionLabels = (variant.selectedOptions || [])
    .filter((option) => option?.value && !isDefaultTitle(option.name) && !isDefaultTitle(option.value))
    .map((option) => `${option.name}: ${option.value}`);

  if (optionLabels.length > 0) {
    return optionLabels.join(' / ');
  }

  const title = selectedVariantTitle(variant);
  return title ? `Size: ${title}` : '';
}

function moneyAmount(money) {
  if (!money) return NaN;
  return Number(money.amount ?? money);
}

function moneyGreaterThan(left, right) {
  const leftAmount = moneyAmount(left);
  const rightAmount = moneyAmount(right);
  return Number.isFinite(leftAmount) && Number.isFinite(rightAmount) && leftAmount > rightAmount;
}

function sameImage(left, right) {
  return Boolean(left?.url && right?.url && left.url === right.url);
}

function getHoverImage(product) {
  const primaryImage = product.featuredImage;
  const secondaryProductImage = (product.images || []).find((image) => image?.url && !sameImage(image, primaryImage));

  if (secondaryProductImage) {
    return secondaryProductImage;
  }

  return product.variants.map((variant) => variant.image).find((image) => image?.url && !sameImage(image, primaryImage)) || null;
}

function getSaleVariant(product) {
  return product.variants.find((variant) => moneyGreaterThan(variant.compareAtPrice, variant.price)) || null;
}

function safeLocalStorageGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (_error) {
    return null;
  }
}

function safeLocalStorageSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (_error) {
    return;
  }
}

function safeLocalStorageRemove(key) {
  try {
    window.localStorage.removeItem(key);
  } catch (_error) {
    return;
  }
}

class PartnerStorefront extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.productIndex = new Map();
    this.state = {
      activeProductId: null,
      cart: null,
      cartBusy: false,
    };

    this.config = this.#readConfig();
    this.refs = this.#collectRefs();

    this.#bindEvents();

    if (!this.config) {
      this.#setStatus('Partner merch configuration is invalid.', 'error');
      return;
    }

    this.cartStorageKey = `northlane-partner-cart:${this.config.domain}`;
    this.publicCartStorageKey = `northlane-partner-public-cart:${this.config.domain}`;
    this.#initialize().catch((error) => this.#handleError(error, 'Unable to load partner merch right now.'));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('change', this.handleChange);
    this.removeEventListener('pointermove', this.handlePointerMove);
    this.removeEventListener('pointerout', this.handlePointerOut);
    document.removeEventListener('click', this.handleDocumentClick, true);
    document.removeEventListener('keydown', this.handleKeydown);

    for (const dialog of [this.refs.cartDialog, this.refs.productDialog, this.refs.imageDialog]) {
      dialog?.removeEventListener('click', this.handleDialogClick);
    }
  }

  #collectRefs() {
    return {
      cartCount: this.querySelector('[data-partner-cart-count]'),
      cartDialog: this.querySelector('[data-partner-cart-dialog]'),
      cartDialogCheckout: this.querySelector('[data-partner-cart-dialog-checkout]'),
      cartDialogSubtotal: this.querySelector('[data-partner-cart-dialog-subtotal]'),
      cartLines: this.querySelector('[data-partner-cart-lines]'),
      checkoutLink: this.querySelector('[data-partner-checkout-link]'),
      productDialog: this.querySelector('[data-partner-product-dialog]'),
      productDialogBody: this.querySelector('[data-partner-product-dialog-body]'),
      productDialogTitle: this.querySelector('[data-partner-product-dialog-title]'),
      imageDialog: this.querySelector('[data-partner-image-dialog]'),
      imageDialogBody: this.querySelector('[data-partner-image-dialog-body]'),
      productPage: this.querySelector('[data-partner-product-page]'),
      productPageBody: this.querySelector('[data-partner-product-page-body]'),
      collectionContent: this.querySelector('[data-partner-collection-content]'),
      status: this.querySelector('[data-partner-status]'),
      toolbar: this.querySelector('[data-partner-toolbar]'),
      toolbarShell: this.querySelector('[data-partner-toolbar-shell]'),
      subtotal: this.querySelector('[data-partner-cart-subtotal]'),
    };
  }

  #readConfig() {
    const config = parseJsonScript(this.querySelector('[data-partner-config]'));
    if (!config) return null;

    const groups = Array.isArray(config.groups) ? config.groups.filter((group) => group?.identifier) : [];
    if (groups.length === 0) return null;

    return {
      ...config,
      apiVersion: String(config.apiVersion || DEFAULT_API_VERSION),
      country: String(config.country || DEFAULT_COUNTRY).toUpperCase(),
      language: String(config.language || DEFAULT_LANGUAGE).toUpperCase(),
      locale: String(config.locale || DEFAULT_LOCALE_BY_COUNTRY[String(config.country || DEFAULT_COUNTRY).toUpperCase()] || 'en-AU'),
      domain: String(config.domain || '').trim(),
      storefrontToken: String(config.storefrontToken || '').trim(),
      productsPerCollection: Number(config.productsPerCollection || 24),
      groups,
    };
  }

  #bindEvents() {
    this.handleClick = this.#handleClick.bind(this);
    this.handleChange = this.#handleChange.bind(this);
    this.handleDocumentClick = this.#handleDocumentClick.bind(this);
    this.handleKeydown = this.#handleKeydown.bind(this);
    this.handleDialogClick = this.#handleDialogClick.bind(this);
    this.handlePointerMove = this.#handlePointerMove.bind(this);
    this.handlePointerOut = this.#handlePointerOut.bind(this);

    this.addEventListener('click', this.handleClick);
    this.addEventListener('change', this.handleChange);
    this.addEventListener('pointermove', this.handlePointerMove);
    this.addEventListener('pointerout', this.handlePointerOut);
    document.addEventListener('click', this.handleDocumentClick, true);
    document.addEventListener('keydown', this.handleKeydown);

    for (const dialog of [this.refs.cartDialog, this.refs.productDialog, this.refs.imageDialog]) {
      dialog?.addEventListener('click', this.handleDialogClick);
    }
  }

  async #initialize() {
    if (!this.config.domain || !this.config.storefrontToken) {
      this.#setStatus('Partner merch is ready to wire up, but the store domain or storefront token is still missing.', 'error');
      return;
    }

    const productHandle = this.#currentProductHandle();

    if (productHandle) {
      this.#setCollectionHeadingHidden(true);
      await this.#showProductPage(productHandle);
      await this.#refreshCart({ suppressErrors: true });
      return;
    }

    this.#setCollectionHeadingHidden(false);

    const loadResults = await Promise.all(this.config.groups.map((group) => this.#loadGroup(group)));
    const anyLoaded = loadResults.some(Boolean);

    if (anyLoaded) {
      this.#setStatus('');
    } else {
      this.#setStatus('No partner merch is available with the current configuration.', 'error');
    }

    await this.#refreshCart({ suppressErrors: true });
  }

  async #loadGroup(group) {
    const section = this.querySelector(`[data-partner-group-key="${group.key}"]`);
    const list = section?.querySelector('[data-partner-grid]');
    const loading = section?.querySelector('[data-partner-loading]');
    const empty = section?.querySelector('[data-partner-empty]');

    if (!section || !list) return false;

    try {
      const collection = await this.#fetchCollection(group.identifier);
      const products = sortPartnerProducts((collection?.products?.nodes || []).map(normalizeProduct));

      if (products.length === 0) {
        loading?.setAttribute('hidden', '');

        if (group.key === 'default') {
          empty?.removeAttribute('hidden');
        } else {
          section.hidden = true;
        }

        return false;
      }

      if (group.show_heading) {
        const heading = section.querySelector('[data-partner-heading]');
        if (heading && !heading.textContent?.trim()) {
          heading.textContent = collection.title || group.title || '';
        }
      }

      list.innerHTML = products.map((product, index) => this.#renderProductCard(product, index)).join('');
      loading?.setAttribute('hidden', '');
      empty?.setAttribute('hidden', '');
      return true;
    } catch (error) {
      console.error(`Partner merch group "${group.key}" failed:`, error);
      loading?.setAttribute('hidden', '');

      if (group.key === 'default') {
        empty?.removeAttribute('hidden');
      } else {
        section.hidden = true;
      }

      return false;
    }
  }

  async #fetchCollection(identifier) {
    const normalized = normalizeCollectionIdentifier(identifier);
    if (!normalized) return null;

    const query = buildCollectionQuery(this.config.country, this.config.language, normalized.type);
    const variables = normalized.type === 'id'
      ? { id: normalized.value, first: this.config.productsPerCollection }
      : { handle: normalized.value, first: this.config.productsPerCollection };

    const data = await this.#request(query, variables);
    const collection = data.collection || null;
    const hasProducts = (collection?.products?.nodes || []).length > 0;
    if (hasProducts) return collection;

    const fallbackHandle = collection?.handle || (normalized.type === 'handle' ? normalized.value : '');
    const fallbackCollection = await this.#fetchPublicCollection(fallbackHandle);
    return fallbackCollection || collection;
  }

  async #fetchPublicCollection(handle) {
    const safeHandle = String(handle || '').trim();
    if (!safeHandle) return null;

    try {
      const response = await fetch(`https://${this.#publicDomain()}/collections/${encodeURIComponent(safeHandle)}/products.json?limit=100`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return null;

      const payload = await response.json();
      const products = (payload.products || []).map((product) => normalizePublicProduct(product));
      return {
        title: safeHandle,
        handle: safeHandle,
        products: {
          nodes: products,
        },
      };
    } catch (error) {
      console.warn(`Unable to load public partner collection "${safeHandle}":`, error);
      return null;
    }
  }

  async #fetchProduct(handle) {
    const normalizedHandle = String(handle || '').trim();
    if (!normalizedHandle) return null;

    try {
      const data = await this.#request(buildProductQuery(this.config.country, this.config.language), {
        handle: normalizedHandle,
      });

      if (data.product) return normalizeProduct(data.product);
    } catch (error) {
      console.warn(`Partner storefront product request failed for "${normalizedHandle}"; trying public product JSON.`, error);
    }

    return this.#fetchPublicProduct(normalizedHandle);
  }

  async #fetchPublicProduct(handle) {
    const safeHandle = String(handle || '').trim();
    if (!safeHandle) return null;

    try {
      const publicDomain = this.#publicDomain();
      const publicOrigin = `https://${publicDomain}`;
      const response = await fetch(`${publicOrigin}/products/${encodeURIComponent(safeHandle)}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return null;

      const product = await response.json();
      return normalizePublicProduct(product, 'AUD', publicOrigin);
    } catch (error) {
      console.warn(`Unable to load public partner product "${safeHandle}":`, error);
      return null;
    }
  }

  #publicDomain() {
    if (/imprint/i.test(this.config.domain)) return 'imprintmerch.com.au';

    return this.config.domain;
  }

  async #request(query, variables = {}) {
    const response = await fetch(`https://${this.config.domain}/api/${this.config.apiVersion}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.config.storefrontToken,
      },
      body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
      throw new Error(`Partner storefront request failed with status ${response.status}`);
    }

    const payload = await response.json();

    if (Array.isArray(payload.errors) && payload.errors.length > 0) {
      throw new Error(payload.errors.map((error) => error.message).join(', '));
    }

    return payload.data || {};
  }

  #renderProductCard(product, index) {
    this.productIndex.set(product.id, product);

    const productUrl = this.#productUrl(product);
    const priceMarkup = this.#renderProductPrice(product);
    const hoverImage = getHoverImage(product);
    const primaryImageMarkup = this.#renderImage(product.featuredImage, product.title, {
      className: hoverImage ? 'partner-merch-card__image partner-merch-card__image--primary' : 'partner-merch-card__image',
    });
    const hoverImageMarkup = hoverImage
      ? this.#renderImage(hoverImage, product.title, {
        className: 'partner-merch-card__image partner-merch-card__image--hover',
        loading: 'eager',
      })
      : '';

    return `
      <li
        id="partner-product-${escapeHtml(product.id)}"
        class="product-grid__item product-grid__item--${index}"
        data-product-id="${escapeHtml(product.id)}"
      >
        <article class="product-card size-style partner-merch-card" data-partner-product-card>
          <div
            class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style gap-style partner-merch-card__content"
            style="--product-card-gap: 4px;"
          >
            <a
              class="partner-merch-card__media-link"
              href="${escapeHtml(productUrl)}"
              aria-label="View ${escapeHtml(product.title)}"
            >
              <div class="product-media-container partner-merch-card__media">
                ${primaryImageMarkup}
                ${hoverImageMarkup}
              </div>
            </a>

            <a
              class="partner-merch-card__details-link"
              href="${escapeHtml(productUrl)}"
              aria-label="View ${escapeHtml(product.title)}"
            >
              <div class="text-block">
                <p class="product-title">${escapeHtml(product.title)}</p>
              </div>
              <div class="price">
                ${priceMarkup}
              </div>
            </a>
          </div>
        </article>
      </li>
    `;
  }

  #productUrl(product) {
    if (product?.handle) {
      const url = new URL(window.location.href);
      url.searchParams.delete('product');
      url.searchParams.set('partner_product', product.handle);
      return `${url.pathname}${url.search}`;
    }

    return '#';
  }

  #renderImage(image, fallbackAlt, { className = '', loading = 'lazy' } = {}) {
    if (!image?.url) {
      return `<div class="partner-merch-card__meta">Image unavailable</div>`;
    }

    const width = Number(image.width || 800);
    const height = Number(image.height || 800);
    const classAttribute = className ? ` class="${escapeHtml(className)}"` : '';

    return `
      <img
        ${classAttribute}
        src="${escapeHtml(image.url)}"
        alt="${escapeHtml(image.altText || fallbackAlt || '')}"
        width="${width}"
        height="${height}"
        loading="${escapeHtml(loading)}"
      >
    `;
  }

  #renderProductPrice(product) {
    const saleVariant = getSaleVariant(product);
    const priceLabel = this.#formatProductPrice(product);

    if (!saleVariant) {
      return `
        <div class="price__regular">
          <span class="price">${escapeHtml(priceLabel)}</span>
        </div>
      `;
    }

    return this.#renderSalePrice(priceLabel, this.#formatCompareAtPrice(product, saleVariant));
  }

  #renderVariantPrice(variant, product) {
    if (variant?.price && moneyGreaterThan(variant.compareAtPrice, variant.price)) {
      return this.#renderSalePrice(this.#formatMoney(variant.price), this.#formatMoney(variant.compareAtPrice));
    }

    const priceLabel = variant?.price ? this.#formatMoney(variant.price) : this.#formatProductPrice(product);

    return `
      <div class="price__regular">
        <span class="price">${escapeHtml(priceLabel)}</span>
      </div>
    `;
  }

  #renderSalePrice(saleLabel, compareAtLabel) {
    return `
      <div class="price__sale">
        <span class="price-item__group">
          <span class="visually-hidden">Sale price&nbsp;</span>
          <span class="price-item--sale price">${escapeHtml(saleLabel)}</span>
        </span>
        <span class="price-item__group">
          <span class="visually-hidden">Regular price&nbsp;</span>
          <span class="price-item--regular compare-at-price">${escapeHtml(compareAtLabel)}</span>
        </span>
      </div>
    `;
  }

  #formatCompareAtPrice(product, saleVariant) {
    const saleVariants = product.variants.filter((variant) => moneyGreaterThan(variant.compareAtPrice, variant.price));
    const compareAtPrices = saleVariants
      .map((variant) => variant.compareAtPrice)
      .filter(Boolean)
      .sort((left, right) => moneyAmount(left) - moneyAmount(right));

    if (compareAtPrices.length === 0) {
      return this.#formatMoney(saleVariant.compareAtPrice);
    }

    const min = compareAtPrices[0];
    const max = compareAtPrices[compareAtPrices.length - 1];

    if (moneyAmount(min) !== moneyAmount(max)) {
      return `${this.#formatMoney(min)} - ${this.#formatMoney(max)}`;
    }

    return this.#formatMoney(min);
  }

  #formatProductPrice(product) {
    const min = product.priceRange?.minVariantPrice;
    const max = product.priceRange?.maxVariantPrice;

    if (!min) return '';

    const minAmount = Number(min.amount || 0);
    const maxAmount = Number(max?.amount || min.amount || 0);
    const formattedMin = this.#formatMoney(min);

    if (!Number.isFinite(maxAmount) || maxAmount === minAmount) {
      return formattedMin;
    }

    return `From ${formattedMin}`;
  }

  #formatMoney(money) {
    if (!money) return '';

    const amount = typeof money.amount === 'string' ? Number(money.amount) : Number(money);
    const currency = money.currencyCode || 'AUD';

    return new Intl.NumberFormat(this.config.locale, {
      style: 'currency',
      currency,
    }).format(amount);
  }

  #handleClick(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const closeTrigger = target.closest('[data-partner-close-dialog]');
    if (closeTrigger) {
      const dialog = closeTrigger.closest('dialog');
      if (dialog instanceof HTMLDialogElement) {
        dialog.close();
      }
      return;
    }

    const openCartTrigger = target.closest('[data-partner-open-cart]');
    if (openCartTrigger) {
      this.#setStatus('');
      this.#renderCart(this.state.cart);
      this.#openDialog(this.refs.cartDialog);
      return;
    }

    const openProductTrigger = target.closest('[data-open-product-id]');
    if (openProductTrigger) {
      const productId = openProductTrigger.getAttribute('data-open-product-id');
      if (productId) {
        this.#openProduct(productId);
      }
      return;
    }

    const addVariantTrigger = target.closest('[data-add-variant-id]');
    if (addVariantTrigger) {
      const variantId = addVariantTrigger.getAttribute('data-add-variant-id');
      if (variantId) {
        this.#addToCart([{ merchandiseId: variantId, quantity: 1 }], { openCart: true }).catch((error) => {
          this.#handleError(error, 'Unable to add this item to the merch cart.');
        });
      }
      return;
    }

    const modalAddTrigger = target.closest('[data-partner-modal-add]');
    if (modalAddTrigger) {
      const variantId = modalAddTrigger.getAttribute('data-partner-modal-variant-id');
      const quantityInput = this.refs.productDialogBody?.querySelector('[data-partner-product-quantity]');
      const quantity = Math.max(1, Number(quantityInput?.value || 1));

      if (variantId) {
        this.#addToCart([{ merchandiseId: variantId, quantity }], { openCart: true }).then(() => {
          this.refs.productDialog?.close();
        }).catch((error) => {
          this.#handleError(error, 'Unable to add this item to the merch cart.');
        });
      }
      return;
    }

    const pageThumbnailTrigger = target.closest('[data-partner-product-thumbnail]');
    if (pageThumbnailTrigger) {
      const imageContainer = this.refs.productPageBody?.querySelector('[data-partner-product-page-image]');
      const image = {
        url: pageThumbnailTrigger.getAttribute('data-image-url'),
        altText: pageThumbnailTrigger.getAttribute('data-image-alt'),
        width: pageThumbnailTrigger.getAttribute('data-image-width'),
        height: pageThumbnailTrigger.getAttribute('data-image-height'),
      };

      if (imageContainer instanceof HTMLElement && image.url) {
        imageContainer.innerHTML = this.#renderImage(image, '', {
          className: 'partner-merch-product-page__main-image',
          loading: 'eager',
        });
        imageContainer.dataset.imageUrl = image.url;
        imageContainer.dataset.imageAlt = image.altText || '';
        imageContainer.dataset.imageWidth = String(image.width || 800);
        imageContainer.dataset.imageHeight = String(image.height || 800);
        imageContainer.setAttribute('aria-label', `Open ${image.altText || 'product'} image fullscreen`);
      }

      for (const thumbnail of this.querySelectorAll('[data-partner-product-thumbnail]')) {
        thumbnail.toggleAttribute('aria-current', thumbnail === pageThumbnailTrigger);
      }

      return;
    }

    const pageImageNavTrigger = target.closest('[data-partner-product-image-nav]');
    if (pageImageNavTrigger) {
      const thumbnails = [...(this.refs.productPageBody?.querySelectorAll('[data-partner-product-thumbnail]') || [])]
        .filter((thumbnail) => thumbnail instanceof HTMLElement);

      if (thumbnails.length > 1) {
        const activeIndex = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.hasAttribute('aria-current')));
        const direction = Number(pageImageNavTrigger.getAttribute('data-partner-product-image-nav') || 1);
        const nextIndex = (activeIndex + direction + thumbnails.length) % thumbnails.length;
        thumbnails[nextIndex]?.click();
      }

      return;
    }

    const pageImageTrigger = target.closest('[data-partner-product-page-image]');
    if (pageImageTrigger) {
      const image = {
        url: pageImageTrigger.getAttribute('data-image-url'),
        altText: pageImageTrigger.getAttribute('data-image-alt'),
        width: pageImageTrigger.getAttribute('data-image-width'),
        height: pageImageTrigger.getAttribute('data-image-height'),
      };

      this.#openImageDialog(image);
      return;
    }

    const pageOptionTrigger = target.closest('[data-partner-product-page-option]');
    if (pageOptionTrigger) {
      const optionGroup = pageOptionTrigger.closest('[data-partner-option-group]');

      for (const optionButton of optionGroup?.querySelectorAll('[data-partner-product-page-option]') || []) {
        optionButton.setAttribute('aria-pressed', optionButton === pageOptionTrigger ? 'true' : 'false');
      }

      this.#syncProductPage();
      return;
    }

    const pageQuantityTrigger = target.closest('[data-partner-product-page-quantity-change]');
    if (pageQuantityTrigger) {
      const quantityInput = this.refs.productPageBody?.querySelector('[data-partner-product-page-quantity]');
      const delta = Number(pageQuantityTrigger.getAttribute('data-partner-product-page-quantity-change') || 0);

      if (quantityInput instanceof HTMLInputElement) {
        quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) + delta));
      }

      return;
    }

    const pageAddTrigger = target.closest('[data-partner-product-page-add]');
    if (pageAddTrigger) {
      const variantId = pageAddTrigger.getAttribute('data-partner-product-page-variant-id');
      const quantityInput = this.refs.productPageBody?.querySelector('[data-partner-product-page-quantity]');
      const quantity = Math.max(1, Number(quantityInput?.value || 1));

      if (variantId) {
        this.#addToCart([{ merchandiseId: variantId, quantity }], { openCart: true }).catch((error) => {
          this.#handleError(error, 'Unable to add this item to the merch cart.');
        });
      }

      return;
    }

    const cartChangeTrigger = target.closest('[data-partner-cart-change]');
    if (cartChangeTrigger) {
      const lineId = cartChangeTrigger.getAttribute('data-line-id');
      const quantity = Number(cartChangeTrigger.getAttribute('data-quantity') || 0);
      if (!lineId) return;

      if (quantity <= 0) {
        this.#removeCartLines([lineId]).catch((error) => {
          this.#handleError(error, 'Unable to update the merch cart.');
        });
      } else {
        this.#updateCartLines([{ id: lineId, quantity }]).catch((error) => {
          this.#handleError(error, 'Unable to update the merch cart.');
        });
      }
    }
  }

  #handleDocumentClick(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || this.contains(target)) return;

    const cartLink = target.closest('a[href="/cart"], a[href$="/cart"]');
    if (!(cartLink instanceof HTMLAnchorElement)) return;

    const label = `${cartLink.getAttribute('aria-label') || ''} ${cartLink.textContent || ''}`.trim();
    if (!/cart/i.test(label)) return;

    event.preventDefault();
    event.stopPropagation();
    this.#setStatus('');
    this.#renderCart(this.state.cart);
    this.#openDialog(this.refs.cartDialog);
  }

  #handleChange(event) {
    const target = event.target instanceof HTMLElement ? event.target : null;
    if (!target) return;

    if (target.closest('[data-partner-product-dialog-body]') && target.hasAttribute('data-partner-option-name')) {
      this.#syncProductDialog();
    }

    if (target.closest('[data-partner-product-page-root]') && target.hasAttribute('data-partner-option-name')) {
      this.#syncProductPage();
    }
  }

  #handleKeydown(event) {
    if (event.key !== 'Escape') return;

    if (this.refs.imageDialog?.open) {
      this.refs.imageDialog.close();
      return;
    }

    if (this.refs.productDialog?.open) {
      this.refs.productDialog.close();
      return;
    }

    if (this.refs.cartDialog?.open) {
      this.refs.cartDialog.close();
    }
  }

  #handleDialogClick(event) {
    if (event.target instanceof HTMLDialogElement) {
      event.target.close();
    }
  }

  #handlePointerMove(event) {
    const target = event.target instanceof Element ? event.target : null;
    const mediaLink = target?.closest('.partner-merch-card__media-link');

    if (!(mediaLink instanceof HTMLElement)) return;

    const rect = mediaLink.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return;

    const x = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100));
    const y = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100));

    mediaLink.style.setProperty('--partner-media-x', `${x.toFixed(2)}%`);
    mediaLink.style.setProperty('--partner-media-y', `${y.toFixed(2)}%`);
  }

  #handlePointerOut(event) {
    const target = event.target instanceof Element ? event.target : null;
    const mediaLink = target?.closest('.partner-merch-card__media-link');

    if (!(mediaLink instanceof HTMLElement)) return;
    if (event.relatedTarget instanceof Node && mediaLink.contains(event.relatedTarget)) return;

    mediaLink.style.removeProperty('--partner-media-x');
    mediaLink.style.removeProperty('--partner-media-y');
  }

  #currentProductHandle() {
    try {
      const params = new URLSearchParams(window.location.search);
      return String(params.get('partner_product') || params.get('product') || params.get('handle') || '').trim();
    } catch (_error) {
      return '';
    }
  }

  #collectionUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete('partner_product');
    url.searchParams.delete('product');
    url.searchParams.delete('handle');
    return `${url.pathname}${url.search}`;
  }

  #setCollectionHeadingHidden(hidden) {
    const main = this.closest('main') || document.querySelector('main');
    const heading = [...(main?.querySelectorAll('h1') || [])]
      .find((element) => element.textContent?.trim().toUpperCase() === 'ALL MERCHANDISE');
    const section = heading?.closest('.shopify-section.section-wrapper') || heading?.closest('.section') || heading?.parentElement;

    if (!(section instanceof HTMLElement)) return;

    section.hidden = hidden;
    section.toggleAttribute('data-partner-collection-heading-hidden', hidden);
  }

  async #showProductPage(handle) {
    if (this.refs.collectionContent instanceof HTMLElement) {
      this.refs.collectionContent.hidden = true;
    }

    if (this.refs.productPage instanceof HTMLElement) {
      this.refs.productPage.hidden = false;
    }

    this.#setStatus('Loading merch...');

    try {
      const product = await this.#fetchProduct(handle);

      if (!product) {
        throw new Error(`No partner product found for handle "${handle}".`);
      }

      this.productIndex.set(product.id, product);

      const initialVariant = getFirstAvailableVariant(product);
      const selectedOptions = optionMapFromVariant(initialVariant);

      if (this.refs.productPageBody instanceof HTMLElement) {
        this.refs.productPageBody.innerHTML = this.#renderProductPage(product, selectedOptions);
      }

      this.#syncProductPage();
      this.#setStatus('');
      this.#loadRelatedProducts(product).catch((error) => {
        console.error('Partner merch related products failed:', error);
      });
    } catch (error) {
      console.error('Partner merch product failed:', error);
      this.#setStatus('Unable to load this merch item right now.', 'error');

      if (this.refs.productPageBody instanceof HTMLElement) {
        this.refs.productPageBody.innerHTML = `
          <div class="partner-merch-product-page__empty">
            <a class="partner-merch-product-page__back" href="${escapeHtml(this.#collectionUrl())}">
              <span class="partner-merch-product-page__back-icon" aria-hidden="true">
                <svg viewBox="0 0 20 20" focusable="false">
                  <path fill-rule="evenodd" d="M11.764 5.204a.75.75 0 0 1 .032 1.06l-3.516 3.736 3.516 3.736a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z"></path>
                </svg>
              </span>
              <span>Back to all merchandise</span>
            </a>
          </div>
        `;
      }
    }
  }

  #renderProductPage(product, selectedOptions) {
    const optionMarkup = productHasVariantChoices(product)
      ? `
        <div class="partner-merch-product-page__options">
          ${product.options.map((option) => `
            <fieldset class="partner-merch-product-page__option-group" data-partner-option-group>
              <legend>${escapeHtml(option.name)}</legend>
              <div class="partner-merch-product-page__option-values">
                ${option.values.map((value) => `
                  <button
                    type="button"
                    class="partner-merch-product-page__option-button"
                    data-partner-product-page-option
                    data-partner-option-name="${escapeHtml(option.name)}"
                    data-partner-option-value="${escapeHtml(value)}"
                    aria-pressed="${selectedOptions[option.name] === value ? 'true' : 'false'}"
                  >
                    ${escapeHtml(value)}
                  </button>
                `).join('')}
              </div>
            </fieldset>
          `).join('')}
        </div>
      `
      : '';

    const descriptionMarkup = product.descriptionHtml
      ? `<div class="partner-merch-product-page__description rte">${product.descriptionHtml}</div>`
      : '';
    const ticketNoticeMarkup = partnerProductIsAnemoiaReleasePartyTicket(product)
      ? `
        <p class="partner-merch-product-page__ticket-notice">
          ALL SALES ARE FINAL // QUERIES CAN BE DIRECTED TO:
          <a href="mailto:info@immortalmusicgroup.com">INFO@IMMORTALMUSICGROUP.COM</a>
        </p>
      `
      : '';


    return `
      <article class="partner-merch-product-page__article" data-partner-product-page-root data-product-id="${escapeHtml(product.id)}">
        <a class="partner-merch-product-page__back" href="${escapeHtml(this.#collectionUrl())}">
          <span class="partner-merch-product-page__back-icon" aria-hidden="true">
            <svg viewBox="0 0 20 20" focusable="false">
              <path fill-rule="evenodd" d="M11.764 5.204a.75.75 0 0 1 .032 1.06l-3.516 3.736 3.516 3.736a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z"></path>
            </svg>
          </span>
          <span>Back to all merchandise</span>
        </a>

        <div class="partner-merch-product-page__layout">
          <div class="partner-merch-product-page__gallery" data-partner-product-page-gallery>
            ${this.#renderProductPageGallery(product, getFirstAvailableVariant(product))}
          </div>

          <div class="partner-merch-product-page__details">
            <p class="partner-merch-product-page__brand">Northlane</p>
            <h1 class="partner-merch-product-page__title">${escapeHtml(product.title)}</h1>
            <div class="price partner-merch-product-page__price" data-partner-product-page-price></div>
            <p class="partner-merch-product-page__checkout-note">Shipping calculated at checkout.</p>
            ${ticketNoticeMarkup}

            <hr class="partner-merch-product-page__divider">

            ${optionMarkup}

            <div class="partner-merch-product-page__quantity-field">
              <span>Quantity</span>
              <div class="partner-merch-product-page__quantity-control">
                <button
                  type="button"
                  class="button-unstyled partner-merch-product-page__quantity-button"
                  data-partner-product-page-quantity-change="-1"
                  aria-label="Decrease quantity"
                >
                  -
                </button>
                <input
                  type="number"
                  min="1"
                  step="1"
                  value="1"
                  inputmode="numeric"
                  aria-label="Quantity"
                  data-partner-product-page-quantity
                >
                <button
                  type="button"
                  class="button-unstyled partner-merch-product-page__quantity-button"
                  data-partner-product-page-quantity-change="1"
                  aria-label="Increase quantity"
                >
                  +
                </button>
              </div>
            </div>

            <div class="partner-merch-product-page__actions">
              <button type="button" class="button partner-merch-product-page__add-button" data-partner-product-page-add data-partner-product-page-variant-id="">
                Add to cart
              </button>
              <button type="button" class="button-secondary partner-merch-product-page__cart-button" data-partner-open-cart>
                VIEW CART
              </button>
            </div>

            ${descriptionMarkup}

            <div class="partner-merch-product-page__accordions">
              <details>
                <summary>Size chart</summary>
                <div>
                  ${renderImprintSizeChart()}
                </div>
              </details>
              <details>
                <summary>Shipping information</summary>
                <div class="partner-merch-shipping-info">
                  <p>Orders are generally shipped 2-4 business days from when the order is placed, regardless of shipping method chosen.</p>
                  <p>All Items are shipped using Australia Post.<br>Tracking information will be e-mailed to you as soon as your order can be fulfilled from our warehouse.</p>
                  <p>**Please note if you purchased additional merchandise<br>in the same order as a PRE-ORDER item, your entire order will be put on hold until the PRE-ORDER item is ready to ship.</p>
                  <p>***Items that are "Print On Demand" items can have an additional 1-4 business day of production time before the order dispatches from when the order is placed, regardless of shipping method chosen.</p>
                  <div class="partner-merch-product-page__fulfillment" aria-label="Fulfillment serviced by Imprint Merch">
                    <span class="partner-merch-product-page__fulfillment-label">Fulfillment serviced by</span>
                    <img
                      class="partner-merch-product-page__fulfillment-logo"
                      src="${escapeHtml(IMPRINT_MERCH_LOGO)}"
                      alt="Imprint Merch"
                      width="96"
                      height="36"
                      loading="lazy"
                    >
                  </div>
                </div>
              </details>
            </div>
          </div>
        </div>

        <section class="partner-merch-product-page__related" data-partner-related-products hidden>
          <h2 class="partner-merch-product-page__related-title">You may also like</h2>
          <ul
            class="product-grid partner-merch-product-page__related-grid"
            role="list"
            product-grid-view="default"
            data-product-card-size="medium"
            data-partner-related-grid
          ></ul>
        </section>
      </article>
    `;
  }

  async #loadRelatedProducts(currentProduct) {
    const section = this.refs.productPageBody?.querySelector('[data-partner-related-products]');
    const list = section?.querySelector('[data-partner-related-grid]');

    if (!(section instanceof HTMLElement) || !(list instanceof HTMLElement)) return;

    const products = await this.#fetchRelatedProducts(currentProduct);
    if (products.length === 0) {
      section.hidden = true;
      return;
    }

    list.innerHTML = products.map((product, index) => this.#renderProductCard(product, index)).join('');
    section.hidden = false;
  }

  async #fetchRelatedProducts(currentProduct) {
    const productMap = new Map();
    const collectionResults = await Promise.allSettled(
      this.config.groups.map((group) => this.#fetchCollection(group.identifier))
    );

    for (const result of collectionResults) {
      if (result.status !== 'fulfilled') continue;

      for (const product of (result.value?.products?.nodes || []).map(normalizeProduct)) {
        if (!product?.id || product.id === currentProduct?.id || product.handle === currentProduct?.handle) continue;
        productMap.set(product.id, product);
      }
    }

    const products = [...productMap.values()];
    const randomProducts = shuffleProducts(products.filter((product) => !productIsArchive(product))).slice(0, 4);
    const remainingSlots = Math.max(0, 4 - randomProducts.length);

    if (remainingSlots > 0) {
      randomProducts.push(...shuffleProducts(products.filter(productIsArchive)).slice(0, remainingSlots));
    }

    return randomProducts;
  }

  #renderProductPageGallery(product, variant) {
    const images = this.#productImages(product, variant);
    const mainImage = variant?.image || product.featuredImage || images[0] || null;
    const mainImageAlt = mainImage?.altText || product.title || '';
    const mainImageMarkup = this.#renderImage(mainImage, product.title, {
      className: 'partner-merch-product-page__main-image',
      loading: 'eager',
    });
    const navMarkup = images.length > 1
      ? `
        <button
          type="button"
          class="button-unstyled partner-merch-product-page__image-nav partner-merch-product-page__image-nav--prev"
          data-partner-product-image-nav="-1"
          aria-label="Previous product image"
        >
          <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
            <path fill-rule="evenodd" d="M3.5 10a.75.75 0 0 1 .75-.75h9.69l-2.72-2.72a.75.75 0 1 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06l2.72-2.72h-9.69a.75.75 0 0 1-.75-.75Z"></path>
          </svg>
        </button>
        <button
          type="button"
          class="button-unstyled partner-merch-product-page__image-nav partner-merch-product-page__image-nav--next"
          data-partner-product-image-nav="1"
          aria-label="Next product image"
        >
          <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
            <path fill-rule="evenodd" d="M3.5 10a.75.75 0 0 1 .75-.75h9.69l-2.72-2.72a.75.75 0 1 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06l2.72-2.72h-9.69a.75.75 0 0 1-.75-.75Z"></path>
          </svg>
        </button>
      `
      : '';
    const thumbnailMarkup = images.length > 1
      ? `
        <div class="partner-merch-product-page__thumbnails">
          ${images.map((image) => `
            <button
              type="button"
              class="partner-merch-product-page__thumbnail"
              data-partner-product-thumbnail
              data-image-url="${escapeHtml(image.url)}"
              data-image-alt="${escapeHtml(image.altText || product.title || '')}"
              data-image-width="${escapeHtml(image.width || 800)}"
              data-image-height="${escapeHtml(image.height || 800)}"
              aria-label="View ${escapeHtml(product.title)} image"
              ${sameImage(image, mainImage) ? 'aria-current="true"' : ''}
            >
              ${this.#renderImage(image, product.title)}
            </button>
          `).join('')}
        </div>
      `
      : '';

    return `
      <div class="partner-merch-product-page__main-media">
        <button
          type="button"
          class="button-unstyled partner-merch-product-page__main-image-button"
          data-partner-product-page-image
          data-image-url="${escapeHtml(mainImage?.url || '')}"
          data-image-alt="${escapeHtml(mainImageAlt)}"
          data-image-width="${escapeHtml(mainImage?.width || 800)}"
          data-image-height="${escapeHtml(mainImage?.height || 800)}"
          aria-label="Open ${escapeHtml(mainImageAlt || 'product')} image fullscreen"
        >
          ${mainImageMarkup}
        </button>
        ${navMarkup}
      </div>
      ${thumbnailMarkup}
    `;
  }

  #productImages(product, variant) {
    const images = [
      variant?.image,
      product.featuredImage,
      ...(product.images || []),
      ...product.variants.map((productVariant) => productVariant.image),
    ];
    const seen = new Set();

    return images.filter((image) => {
      if (!image?.url || seen.has(image.url)) return false;
      seen.add(image.url);
      return true;
    });
  }

  #syncProductPage() {
    const root = this.refs.productPageBody?.querySelector('[data-partner-product-page-root]');
    if (!(root instanceof HTMLElement)) return;

    const product = this.productIndex.get(root.dataset.productId || '');
    if (!product) return;

    const selectedOptions = {};

    for (const button of root.querySelectorAll('[data-partner-product-page-option][aria-pressed="true"]')) {
      if (!(button instanceof HTMLElement)) continue;
      selectedOptions[button.dataset.partnerOptionName] = button.dataset.partnerOptionValue;
    }

    for (const select of root.querySelectorAll('[data-partner-option-name]')) {
      if (!(select instanceof HTMLSelectElement)) continue;
      selectedOptions[select.dataset.partnerOptionName] = select.value;
    }

    const variant = this.#findVariant(product, selectedOptions) || getFirstAvailableVariant(product);
    const price = root.querySelector('[data-partner-product-page-price]');
    const gallery = root.querySelector('[data-partner-product-page-gallery]');
    const addButton = root.querySelector('[data-partner-product-page-add]');

    if (price) {
      price.innerHTML = this.#renderVariantPrice(variant, product);
    }

    const variantOptions = optionMapFromVariant(variant);
    for (const button of root.querySelectorAll('[data-partner-product-page-option]')) {
      if (!(button instanceof HTMLElement)) continue;
      const isSelected = variantOptions[button.dataset.partnerOptionName] === button.dataset.partnerOptionValue;
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    }

    if (gallery instanceof HTMLElement) {
      gallery.innerHTML = this.#renderProductPageGallery(product, variant);
    }

    if (addButton instanceof HTMLButtonElement) {
      addButton.dataset.partnerProductPageVariantId = variant?.id || '';
      addButton.disabled = !variant?.availableForSale;
      addButton.textContent = variant?.availableForSale ? 'Add to cart' : 'Sold out';
    }
  }

  #openProduct(productId) {
    const product = this.productIndex.get(productId);
    if (!product) return;

    this.state.activeProductId = productId;
    const initialVariant = getFirstAvailableVariant(product);
    const selectedOptions = optionMapFromVariant(initialVariant);

    this.refs.productDialogTitle.textContent = product.title;
    this.refs.productDialogBody.innerHTML = this.#renderProductDialog(product, selectedOptions);
    this.#syncProductDialog();
    this.#openDialog(this.refs.productDialog);
  }

  #openImageDialog(image) {
    if (!image?.url || !(this.refs.imageDialogBody instanceof HTMLElement)) return;

    this.refs.imageDialogBody.innerHTML = this.#renderImage(image, image.altText || 'Product image', {
      className: 'partner-merch-image-dialog__image',
      loading: 'eager',
    });

    this.#openDialog(this.refs.imageDialog);
  }

  #renderProductDialog(product, selectedOptions) {
    const optionMarkup = productHasVariantChoices(product)
      ? `
        <div class="partner-merch-product__options">
          ${product.options.map((option) => `
            <label class="partner-merch-product__field">
              <span>${escapeHtml(option.name)}</span>
              <select data-partner-option-name="${escapeHtml(option.name)}">
                ${option.values.map((value) => `
                  <option value="${escapeHtml(value)}" ${selectedOptions[option.name] === value ? 'selected' : ''}>
                    ${escapeHtml(value)}
                  </option>
                `).join('')}
              </select>
            </label>
          `).join('')}
        </div>
      `
      : '';

    const descriptionMarkup = product.descriptionHtml
      ? `<div class="partner-merch-product__description rte">${product.descriptionHtml}</div>`
      : '';

    return `
      <div class="partner-merch-product" data-partner-product-root data-product-id="${escapeHtml(product.id)}">
        <div class="partner-merch-product__media" data-partner-product-image></div>

        <div class="partner-merch-product__details">
          <h3 class="h4">${escapeHtml(product.title)}</h3>
          <p data-partner-product-variant-title></p>
          <div class="price" data-partner-product-price></div>
          ${descriptionMarkup}
          ${optionMarkup}

          <label class="partner-merch-product__field">
            <span>Quantity</span>
            <input
              type="number"
              min="1"
              step="1"
              value="1"
              inputmode="numeric"
              data-partner-product-quantity
            >
          </label>

          <div class="partner-merch-product__actions">
            <button type="button" class="button" data-partner-modal-add data-partner-modal-variant-id="">
              Add to cart
            </button>
            <button type="button" class="button-secondary" data-partner-open-cart>
              VIEW CART
            </button>
          </div>
        </div>
      </div>
    `;
  }

  #syncProductDialog() {
    const root = this.refs.productDialogBody?.querySelector('[data-partner-product-root]');
    if (!(root instanceof HTMLElement)) return;

    const product = this.productIndex.get(root.dataset.productId || '');
    if (!product) return;

    const selectedOptions = {};
    for (const select of root.querySelectorAll('[data-partner-option-name]')) {
      if (!(select instanceof HTMLSelectElement)) continue;
      selectedOptions[select.dataset.partnerOptionName] = select.value;
    }

    const variant = this.#findVariant(product, selectedOptions) || getFirstAvailableVariant(product);
    const variantTitle = root.querySelector('[data-partner-product-variant-title]');
    const price = root.querySelector('[data-partner-product-price]');
    const imageContainer = root.querySelector('[data-partner-product-image]');
    const addButton = root.querySelector('[data-partner-modal-add]');

    if (variantTitle) {
      variantTitle.textContent = selectedVariantTitle(variant) || '';
      variantTitle.hidden = !selectedVariantTitle(variant);
    }

    if (price) {
      price.innerHTML = this.#renderVariantPrice(variant, product);
    }

    if (imageContainer instanceof HTMLElement) {
      imageContainer.innerHTML = this.#renderImage(variant?.image || product.featuredImage, product.title);
    }

    if (addButton instanceof HTMLButtonElement) {
      addButton.dataset.partnerModalVariantId = variant?.id || '';
      addButton.disabled = !variant?.availableForSale;
      addButton.textContent = variant?.availableForSale ? 'Add to cart' : 'Sold out';
    }
  }

  #findVariant(product, selectedOptions) {
    if (!productHasVariantChoices(product)) {
      return getFirstAvailableVariant(product);
    }

    return product.variants.find((variant) =>
      variant.selectedOptions.every((option) => selectedOptions[option.name] === option.value)
    ) || null;
  }

  #findPublicVariant(merchandiseId) {
    for (const product of this.productIndex.values()) {
      if (product?.source !== 'public_online_store_json') continue;

      const variant = (product.variants || []).find((candidate) => candidate.id === merchandiseId);
      if (variant) return { product, variant };
    }

    return null;
  }

  #publicCartLineFromInput(line) {
    const match = this.#findPublicVariant(line?.merchandiseId);
    if (!match) return null;

    const quantity = Math.max(1, Number(line.quantity || 1));
    const publicVariantId = match.variant.publicVariantId || String(match.variant.id || '').split('/').pop();
    if (!publicVariantId) return null;

    const unitPrice = match.variant.price || match.product.priceRange?.minVariantPrice || { amount: '0.00', currencyCode: 'AUD' };
    const unitAmount = moneyAmount(unitPrice);
    const currencyCode = unitPrice.currencyCode || 'AUD';

    return {
      id: `public:${publicVariantId}`,
      publicVariantId,
      quantity,
      merchandise: {
        ...match.variant,
        image: match.variant.image || match.product.featuredImage || null,
        price: unitPrice,
        product: {
          id: match.product.id,
          title: match.product.title,
          handle: match.product.handle,
        },
      },
      cost: {
        amountPerQuantity: unitPrice,
        totalAmount: {
          amount: Number.isFinite(unitAmount) ? (unitAmount * quantity).toFixed(2) : '0.00',
          currencyCode,
        },
      },
    };
  }

  #publicCartCheckoutUrl(lines) {
    const items = lines
      .map((line) => `${encodeURIComponent(line.publicVariantId || String(line.id || '').replace(/^public:/, ''))}:${line.quantity}`)
      .filter((item) => !item.startsWith(':'))
      .join(',');

    return items ? `https://${this.#publicDomain()}/cart/${items}` : '';
  }

  #buildPublicCart(lines) {
    const normalizedLines = (lines || [])
      .map((line) => ({ ...line, quantity: Math.max(0, Number(line.quantity || 0)) }))
      .filter((line) => line.quantity > 0);
    const subtotal = normalizedLines.reduce((total, line) => {
      const unitPrice = line.cost?.amountPerQuantity || line.merchandise?.price;
      const unitAmount = moneyAmount(unitPrice);
      return total + (Number.isFinite(unitAmount) ? unitAmount * line.quantity : 0);
    }, 0);
    const currencyCode = normalizedLines[0]?.cost?.amountPerQuantity?.currencyCode || 'AUD';

    const linesWithTotals = normalizedLines.map((line) => {
      const unitPrice = line.cost?.amountPerQuantity || line.merchandise?.price || { amount: '0.00', currencyCode };
      const unitAmount = moneyAmount(unitPrice);

      return {
        ...line,
        cost: {
          amountPerQuantity: unitPrice,
          totalAmount: {
            amount: Number.isFinite(unitAmount) ? (unitAmount * line.quantity).toFixed(2) : '0.00',
            currencyCode: unitPrice.currencyCode || currencyCode,
          },
        },
      };
    });

    return {
      id: `public:${this.#publicDomain()}`,
      source: 'public_online_store_cart',
      totalQuantity: linesWithTotals.reduce((total, line) => total + line.quantity, 0),
      checkoutUrl: this.#publicCartCheckoutUrl(linesWithTotals),
      cost: {
        subtotalAmount: {
          amount: subtotal.toFixed(2),
          currencyCode,
        },
      },
      lines: linesWithTotals,
    };
  }

  #loadPublicCart() {
    try {
      const raw = safeLocalStorageGet(this.publicCartStorageKey);
      if (!raw) return null;

      const cart = JSON.parse(raw);
      if (cart?.source !== 'public_online_store_cart') return null;

      return this.#buildPublicCart(cart.lines || []);
    } catch (_error) {
      safeLocalStorageRemove(this.publicCartStorageKey);
      return null;
    }
  }

  #addPublicCartLines(lines) {
    const existingCart = this.state.cart?.source === 'public_online_store_cart' ? this.state.cart : this.#loadPublicCart();
    const lineMap = new Map((existingCart?.lines || []).map((line) => [line.id, line]));

    for (const line of lines) {
      const publicLine = this.#publicCartLineFromInput(line);
      if (!publicLine) return null;

      const existingLine = lineMap.get(publicLine.id);
      lineMap.set(publicLine.id, existingLine
        ? { ...existingLine, quantity: existingLine.quantity + publicLine.quantity }
        : publicLine);
    }

    return this.#buildPublicCart([...lineMap.values()]);
  }

  #updatePublicCartLines(lines) {
    const existingCart = this.state.cart?.source === 'public_online_store_cart' ? this.state.cart : this.#loadPublicCart();
    if (!existingCart) return null;

    const lineMap = new Map(existingCart.lines.map((line) => [line.id, line]));
    for (const line of lines) {
      if (!line?.id || !lineMap.has(line.id)) continue;
      lineMap.set(line.id, { ...lineMap.get(line.id), quantity: Math.max(0, Number(line.quantity || 0)) });
    }

    return this.#buildPublicCart([...lineMap.values()]);
  }

  #removePublicCartLines(lineIds) {
    const existingCart = this.state.cart?.source === 'public_online_store_cart' ? this.state.cart : this.#loadPublicCart();
    if (!existingCart) return null;

    const removeIds = new Set(lineIds || []);
    return this.#buildPublicCart(existingCart.lines.filter((line) => !removeIds.has(line.id)));
  }

  async #addToCart(lines, { openCart = false } = {}) {
    if (this.state.cartBusy) return;

    this.state.cartBusy = true;

    try {
      const publicCart = this.#addPublicCartLines(lines);
      if (publicCart) {
        this.#setCart(publicCart);
        this.#setStatus('');

        if (openCart && publicCart.totalQuantity) {
          this.#openDialog(this.refs.cartDialog);
        }

        return;
      }

      let cart = null;
      const cartId = safeLocalStorageGet(this.cartStorageKey);

      if (cartId) {
        cart = await this.#mutateCart(CART_LINES_ADD_MUTATION, 'cartLinesAdd', { cartId, lines });
      } else {
        cart = await this.#mutateCart(CART_CREATE_MUTATION, 'cartCreate', {
          lines,
          country: this.config.country,
        });
      }

      this.#setCart(cart);
      this.#setStatus('');

      if (openCart && cart?.totalQuantity) {
        this.#openDialog(this.refs.cartDialog);
      }
    } finally {
      this.state.cartBusy = false;
    }
  }

  async #updateCartLines(lines) {
    if (this.state.cartBusy) return;

    if (this.state.cart?.source === 'public_online_store_cart') {
      this.#setCart(this.#updatePublicCartLines(lines));
      return;
    }

    const cartId = safeLocalStorageGet(this.cartStorageKey);
    if (!cartId) return;

    this.state.cartBusy = true;

    try {
      const cart = await this.#mutateCart(CART_LINES_UPDATE_MUTATION, 'cartLinesUpdate', { cartId, lines });
      this.#setCart(cart);
    } finally {
      this.state.cartBusy = false;
    }
  }

  async #removeCartLines(lineIds) {
    if (this.state.cartBusy) return;

    if (this.state.cart?.source === 'public_online_store_cart') {
      this.#setCart(this.#removePublicCartLines(lineIds));
      return;
    }

    const cartId = safeLocalStorageGet(this.cartStorageKey);
    if (!cartId) return;

    this.state.cartBusy = true;

    try {
      const cart = await this.#mutateCart(CART_LINES_REMOVE_MUTATION, 'cartLinesRemove', { cartId, lineIds });
      this.#setCart(cart);
    } finally {
      this.state.cartBusy = false;
    }
  }

  async #mutateCart(query, operationName, variables) {
    const data = await this.#request(query, variables);
    const payload = data[operationName];

    if (!payload) {
      throw new Error(`Partner cart mutation "${operationName}" returned no payload.`);
    }

    if (Array.isArray(payload.userErrors) && payload.userErrors.length > 0) {
      throw new Error(payload.userErrors.map((error) => error.message).join(', '));
    }

    return normalizeCart(payload.cart);
  }

  async #refreshCart({ suppressErrors = false } = {}) {
    const cartId = safeLocalStorageGet(this.cartStorageKey);

    if (!cartId) {
      const publicCart = this.#loadPublicCart();
      this.#setCart(publicCart);
      return publicCart;
    }

    try {
      const data = await this.#request(CART_QUERY, { cartId });
      const cart = data.cart ? normalizeCart(data.cart) : null;

      if (!cart) {
        safeLocalStorageRemove(this.cartStorageKey);
      }

      this.#setCart(cart);
      return cart;
    } catch (error) {
      if (!suppressErrors) {
        this.#handleError(error, 'Unable to refresh the merch cart.');
      }
      return null;
    }
  }

  #setCart(cart) {
    this.state.cart = cart;

    if (cart?.source === 'public_online_store_cart') {
      safeLocalStorageRemove(this.cartStorageKey);
      if (cart.totalQuantity > 0) {
        safeLocalStorageSet(this.publicCartStorageKey, JSON.stringify(cart));
      } else {
        safeLocalStorageRemove(this.publicCartStorageKey);
      }
    } else if (cart?.id) {
      safeLocalStorageRemove(this.publicCartStorageKey);
      safeLocalStorageSet(this.cartStorageKey, cart.id);
    } else {
      safeLocalStorageRemove(this.cartStorageKey);
      safeLocalStorageRemove(this.publicCartStorageKey);
    }

    this.#renderCart(cart);
    this.#renderToolbar(cart);
  }

  #renderToolbar(cart) {
    if (!this.refs.toolbar || !this.refs.cartCount || !this.refs.subtotal) return;

    const quantity = cart?.totalQuantity || 0;
    const subtotal = cart?.cost?.subtotalAmount ? this.#formatMoney(cart.cost.subtotalAmount) : '$0.00';

    this.refs.toolbar.hidden = true;
    this.refs.cartCount.textContent = `${quantity} item${quantity === 1 ? '' : 's'}`;
    this.refs.subtotal.textContent = subtotal;

    for (const checkoutLink of [this.refs.checkoutLink, this.refs.cartDialogCheckout]) {
      if (!(checkoutLink instanceof HTMLAnchorElement)) continue;

      if (cart?.checkoutUrl) {
        checkoutLink.href = cart.checkoutUrl;
        checkoutLink.hidden = false;
      } else {
        checkoutLink.hidden = true;
      }
    }

    this.#syncToolbarShellVisibility();
  }

  #renderCart(cart) {
    if (!this.refs.cartLines || !this.refs.cartDialogSubtotal) return;

    if (!cart || cart.lines.length === 0) {
      this.refs.cartLines.innerHTML = '<p class="partner-merch-status">Your merch cart is empty.</p>';
      this.refs.cartDialogSubtotal.textContent = '$0.00';
      return;
    }

    this.refs.cartLines.innerHTML = cart.lines.map((line) => {
      const imageMarkup = this.#renderImage(line.merchandise?.image, line.merchandise?.product?.title || 'Merch item');
      const unitPrice = line.cost?.amountPerQuantity ? this.#formatMoney(line.cost.amountPerQuantity) : '';
      const totalPrice = line.cost?.totalAmount ? this.#formatMoney(line.cost.totalAmount) : '';
      const variantLabel = selectedVariantLabel(line.merchandise);

      return `
        <article class="partner-merch-cart-line">
          <div class="partner-merch-cart-line__image">
            ${imageMarkup}
          </div>

          <div class="partner-merch-cart-line__details">
            <p class="partner-merch-cart-line__title">${escapeHtml(line.merchandise?.product?.title || 'Merch item')}</p>
            ${variantLabel ? `<p class="partner-merch-cart-line__variant">${escapeHtml(variantLabel)}</p>` : ''}
            ${unitPrice ? `<p class="partner-merch-cart-line__unit-price">${escapeHtml(unitPrice)} each</p>` : ''}

            <div class="partner-merch-cart-line__controls">
              <div class="partner-merch-quantity" aria-label="Update quantity">
                <button
                  type="button"
                  class="button-unstyled partner-merch-quantity__button"
                  data-partner-cart-change
                  data-line-id="${escapeHtml(line.id)}"
                  data-quantity="${Math.max(0, line.quantity - 1)}"
                  aria-label="Decrease quantity"
                >
                  -
                </button>
                <span class="partner-merch-quantity__value">${line.quantity}</span>
                <button
                  type="button"
                  class="button-unstyled partner-merch-quantity__button"
                  data-partner-cart-change
                  data-line-id="${escapeHtml(line.id)}"
                  data-quantity="${line.quantity + 1}"
                  aria-label="Increase quantity"
                >
                  +
                </button>
              </div>

              <button
                type="button"
                class="button-unstyled"
                data-partner-cart-change
                data-line-id="${escapeHtml(line.id)}"
                data-quantity="0"
              >
                Remove
              </button>

              <strong>${escapeHtml(totalPrice)}</strong>
            </div>
          </div>
        </article>
      `;
    }).join('');

    this.refs.cartDialogSubtotal.textContent = cart.cost?.subtotalAmount ? this.#formatMoney(cart.cost.subtotalAmount) : '$0.00';
  }

  #setStatus(message, tone = 'info') {
    if (!(this.refs.status instanceof HTMLElement)) return;

    if (!message) {
      this.refs.status.textContent = '';
      this.refs.status.hidden = true;
      this.refs.status.removeAttribute('data-tone');
      this.#syncToolbarShellVisibility();
      return;
    }

    this.refs.status.hidden = false;
    this.refs.status.dataset.tone = tone;
    this.refs.status.textContent = message;
    this.#syncToolbarShellVisibility();
  }

  #syncToolbarShellVisibility() {
    if (!(this.refs.toolbarShell instanceof HTMLElement)) return;

    const toolbarVisible = this.refs.toolbar instanceof HTMLElement && !this.refs.toolbar.hidden;
    const statusVisible = this.refs.status instanceof HTMLElement && !this.refs.status.hidden;
    this.refs.toolbarShell.hidden = !toolbarVisible && !statusVisible;
  }

  #handleError(error, fallbackMessage) {
    console.error('Partner merch error:', error);
    this.#setStatus(fallbackMessage, 'error');
  }

  #openDialog(dialog) {
    if (!(dialog instanceof HTMLDialogElement)) return;

    if (dialog.open) {
      dialog.focus();
      return;
    }

    dialog.showModal();
  }
}

const PARTNER_MUSIC_PATTERN = /\b(vinyl|2lp|lp|record|cd|cassette|tape|album|digital|download)\b/i;
const PARTNER_ACCESSORY_PATTERN = /\b(accessor|tote|bag|sticker|poster|patch|pin|jibbitz|keychain|hat|cap|beanie|flag)\b/i;

function partnerProductSearchText(product) {
  return [
    product?.title,
    product?.handle,
    product?.productType,
    product?.vendor,
    ...(Array.isArray(product?.tags) ? product.tags : []),
  ].filter(Boolean).join(' ');
}

function partnerProductCategory(product) {
  const searchText = partnerProductSearchText(product);

  if (PARTNER_MUSIC_PATTERN.test(searchText)) return 'music';
  if (PARTNER_ACCESSORY_PATTERN.test(searchText)) return 'accessories';
  return 'merchandise';
}

function partnerProductMatchesCategory(product, category) {
  const productCategory = partnerProductCategory(product);

  if (category === 'all') return true;
  if (category === 'non_music') return productCategory !== 'music';

  return productCategory === category;
}
function partnerProductIsAnemoiaReleasePartyTicket(product) {
  const searchText = partnerProductSearchText(product).toLowerCase();
  return searchText.includes('anemoia')
    && (searchText.includes('release party') || searchText.includes('release paty'))
    && /\bticket\b/.test(searchText);
}

function partnerCarouselShouldPrioritizeReleasePartyTicket(config) {
  const collectionIdentifier = String(config?.collectionIdentifier || '').trim();
  const productQuery = String(config?.productQuery || '').trim().toLowerCase();
  const category = String(config?.category || '').trim().toLowerCase();

  return collectionIdentifier === '332633505980'
    && productQuery.includes('anemoia')
    && category === 'music';
}

function prioritizePartnerReleasePartyTicket(products, config) {
  if (!partnerCarouselShouldPrioritizeReleasePartyTicket(config)) return products;

  const releasePartyTickets = [];
  const remainingProducts = [];

  for (const product of products) {
    if (partnerProductIsAnemoiaReleasePartyTicket(product)) {
      releasePartyTickets.push(product);
    } else {
      remainingProducts.push(product);
    }
  }

  return releasePartyTickets.concat(remainingProducts);
}
class PartnerProductListCarousel extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.config = this.#readConfig();
    if (!this.config) return;

    this.#initialize().catch((error) => {
      console.error('Partner product carousel error:', error);
    });
  }

  #readConfig() {
    const config = parseJsonScript(this.querySelector('[data-partner-product-list-config]'));
    if (!config?.collectionIdentifier && !config?.productQuery) return null;

    return {
      apiVersion: String(config.apiVersion || DEFAULT_API_VERSION),
      country: String(config.country || DEFAULT_COUNTRY).toUpperCase(),
      language: String(config.language || DEFAULT_LANGUAGE).toUpperCase(),
      locale: String(config.locale || DEFAULT_LOCALE_BY_COUNTRY[String(config.country || DEFAULT_COUNTRY).toUpperCase()] || 'en-AU'),
      domain: String(config.domain || '').trim(),
      storefrontToken: String(config.storefrontToken || '').trim(),
      collectionIdentifier: String(config.collectionIdentifier || '').trim(),
      productQuery: String(config.productQuery || '').trim(),
      category: String(config.category || 'merchandise').trim().toLowerCase(),
      maxProducts: Math.max(1, Number(config.maxProducts || 16)),
    };
  }

  async #initialize() {
    if (!this.config.domain || !this.config.storefrontToken) return;

    const productNodes = this.config.productQuery
      ? await this.#fetchProductsByQuery(this.config.productQuery)
      : (await this.#fetchCollection(this.config.collectionIdentifier))?.products?.nodes || [];
    const products = prioritizePartnerReleasePartyTicket(
      sortPartnerProducts(productNodes.map(normalizeProduct))
        .filter((product) => product.availableForSale !== false)
        .filter((product) => partnerProductMatchesCategory(product, this.config.category)),
      this.config
    ).slice(0, this.config.maxProducts);

    if (products.length === 0) return;

    this.#renderProducts(products);
  }

  async #fetchCollection(identifier) {
    const normalized = normalizeCollectionIdentifier(identifier);
    if (!normalized) return null;

    const query = buildCollectionQuery(this.config.country, this.config.language, normalized.type);
    const variables = normalized.type === 'id'
      ? { id: normalized.value, first: 100 }
      : { handle: normalized.value, first: 100 };

    const data = await this.#request(query, variables);
    const collection = data.collection || null;
    const hasProducts = (collection?.products?.nodes || []).length > 0;
    if (hasProducts) return collection;

    const fallbackHandle = collection?.handle || (normalized.type === 'handle' ? normalized.value : '');
    const fallbackCollection = await this.#fetchPublicCollection(fallbackHandle);
    return fallbackCollection || collection;
  }

  async #fetchPublicCollection(handle) {
    const safeHandle = String(handle || '').trim();
    if (!safeHandle) return null;

    const response = await fetch(`https://${this.#publicDomain()}/collections/${encodeURIComponent(safeHandle)}/products.json?limit=100`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;

    const payload = await response.json();
    const products = (payload.products || []).map((product) => normalizePublicProduct(product));
    return {
      title: safeHandle,
      handle: safeHandle,
      products: {
        nodes: products,
      },
    };
  }

  #publicDomain() {
    if (/imprint/i.test(this.config.domain)) return 'imprintmerch.com.au';

    return this.config.domain;
  }

  async #fetchProductsByQuery(productQuery) {
    const normalizedQuery = String(productQuery || '').trim();
    if (!normalizedQuery) return [];

    const query = buildProductSearchQuery(this.config.country, this.config.language);
    const data = await this.#request(query, { query: normalizedQuery, first: 100 });
    return data.products?.nodes || [];
  }

  async #request(query, variables = {}) {
    const response = await fetch(`https://${this.config.domain}/api/${this.config.apiVersion}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.config.storefrontToken,
      },
      body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
      throw new Error(`Partner storefront request failed with status ${response.status}`);
    }

    const payload = await response.json();

    if (Array.isArray(payload.errors) && payload.errors.length > 0) {
      throw new Error(payload.errors.map((error) => error.message).join(', '));
    }

    return payload.data || {};
  }

  #renderProducts(products) {
    const slots = [...this.querySelectorAll('[data-partner-product-card-slot]')];

    slots.forEach((slot, index) => {
      const slide = slot.closest('slideshow-slide');
      const product = products[index];

      if (!product) {
        slot.hidden = true;
        slide?.setAttribute('hidden', '');
        return;
      }

      slot.hidden = false;
      slot.removeAttribute('aria-busy');
      slide?.removeAttribute('hidden');
      slide?.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
      slide?.style.setProperty('--slideshow-timeline', `--slide-${index}`);
      slot.innerHTML = this.#renderProductCard(product, index);
    });

    this.classList.add('partner-product-list-carousel--hydrated');
    this.#syncSlideshow(products.length);
  }

  #syncSlideshow(productCount) {
    const slideshow = this.querySelector('slideshow-component.resource-list__carousel');
    if (!slideshow) return;

    const timeline = Array.from({ length: productCount }, (_item, index) => `--slide-${index}`).join(', ');
    slideshow.style.setProperty('--slideshow-timeline', timeline);
    slideshow.setAttribute('initial-slide', '0');

    requestAnimationFrame(() => {
      if (typeof slideshow.select === 'function') {
        slideshow.select(0, undefined, { animate: false });
      }

      window.dispatchEvent(new Event('resize'));
    });
  }

  #renderProductCard(product, index) {
    const productUrl = this.#productUrl(product);
    const productId = escapeHtml(product.id || product.handle || String(index));
    const safeId = this.#safeId(product.id || product.handle || String(index));
    const image = product.featuredImage || product.images?.[0] || getFirstAvailableVariant(product)?.image || null;
    const hoverImage = getHoverImage(product);
    const mediaId = this.#safeId(image?.url || product.id || product.handle || String(index));
    const ratio = this.#imageRatio(image);
    const primaryImageMarkup = this.#renderImage(
      image,
      product.title,
      index,
      hoverImage ? 'partner-product-list__image partner-product-list__image--primary' : 'partner-product-list__image',
    );
    const hoverImageMarkup = hoverImage
      ? this.#renderImage(
        hoverImage,
        product.title,
        index,
        'partner-product-list__image partner-product-list__image--hover',
        'eager',
      )
      : '';

    return `
      <product-card
        class="product-card size-style"
        style="--size-style-width: ;--size-style-height: ;"
        data-product-id="${productId}"
        id="product-card-partner-${safeId}"
      >
        <a
          id="partner-card-link-${safeId}"
          href="${escapeHtml(productUrl)}"
          class="product-card__link"
          ref="productCardLink"
        >
          <span class="visually-hidden">${escapeHtml(product.title)}</span>
        </a>

        <div
          class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style"
          style="
            --border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px;
            --flex-direction: column; --flex-wrap: nowrap; --flex-wrap-mobile: wrap;
            --horizontal-alignment: ; --vertical-alignment: ; --vertical-alignment-mobile: ;
            --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px;
            --product-card-gap: 0px;
            --quick-add-display: none;
            --quick-add-mobile-display: none;
            --quick-add-mobile-opacity: 0;
          "
        >
          <div
            ref="cardGallery"
            class="card-gallery card-gallery-partner-product-list spacing-style border-style"
            style="
              --border-width: 1px; --border-style: none; --border-color: rgb(var(--color-border-rgb) / 1.0); --border-radius: 0px;
              --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px;
              --gallery-aspect-ratio: 1;
            "
            data-product-id="${productId}"
            data-image-ratio="square"
          >
            <a
              class="contents"
              ref="cardGalleryLink"
              href="${escapeHtml(productUrl)}"
              aria-label="${escapeHtml(product.title)}"
            >
              <slideshow-component
                ref="slideshow"
                style="--slideshow-timeline: --slide-0;--slide-min-height: auto;--slide-min-height-desktop: auto;"
                initial-slide="0"
                data-generic-media-size="1"
              >
                <slideshow-container ref="slideshowContainer">
                  <slideshow-slides tabindex="-1" ref="scroller">
                    <slideshow-slide
                      ref="slides[]"
                      aria-hidden="false"
                      style="--slideshow-timeline: --slide-0; --product-media-fit: cover; --grid-template-rows: 50dvh 1fr; --grid-template-rows-desktop: 70dvh 1fr;"
                      class="product-media-container media-fit product-media-container--image"
                      slide-id="partner-media-${mediaId}"
                    >
                      <div class="product-media" style="--ratio: ${escapeHtml(ratio)}" data-media-id="partner-media-${mediaId}">
                        ${primaryImageMarkup}
                        ${hoverImageMarkup}
                      </div>
                    </slideshow-slide>
                  </slideshow-slides>
                </slideshow-container>
              </slideshow-component>
            </a>

            <div
              class="product-badges product-badges--top-right"
              style="
                --badge-border-radius: 0px;
                --badge-font-family: var(--font-body--family); --badge-font-weight: var(--font-body--weight); --badge-text-transform: uppercase;
              "
            ></div>
          </div>

          <div class="product-grid-view-zoom-out--details">
            <h3 class="h4">${escapeHtml(product.title)}</h3>
          </div>

          <a class="contents user-select-text" ref="productTitleLink" href="${escapeHtml(productUrl)}">
            <rte-formatter
              class="spacing-style text-block text-block--partner-product-list-title rte text-block--align-center"
              style="
                --padding-block-start: 4px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px;
                --width: 100%;
                --max-width: var(--max-width--body-normal);
                --text-align: center;
              "
            >
              <p role="heading" aria-level="3">${escapeHtml(product.title)}</p>
            </rte-formatter>
          </a>

          <product-price
            class="text-block text-block--align-center rte text-center h6 spacing-style"
            data-product-id="${productId}"
            style="
              --padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px;
              --width: 100%;
            "
          >
            ${this.#renderProductPrice(product)}
          </product-price>
        </div>
      </product-card>
    `;
  }

  #productUrl(product) {
    if (!product?.handle) return '/collections/all';

    const url = new URL('/collections/all', window.location.origin);
    url.searchParams.set('partner_product', product.handle);
    return `${url.pathname}${url.search}`;
  }

  #renderImage(image, fallbackAlt, index, className = '', loadingOverride = '') {
    if (!image?.url) {
      return `<span class="visually-hidden">${escapeHtml(fallbackAlt || 'Product image')}</span>`;
    }

    const width = Number(image.width || 1200);
    const height = Number(image.height || 1200);
    const widths = [240, 352, 832, 1200, 1600, 1920].filter((candidate) => candidate <= Math.max(width, 1200));
    const srcset = widths.map((candidate) => `${escapeHtml(this.#imageUrl(image.url, candidate))} ${candidate}w`).join(', ');
    const src = this.#imageUrl(image.url, Math.min(Math.max(width, 1200), 3840));
    const loading = loadingOverride || (index < 4 ? 'eager' : 'lazy');
    const imageClass = ['product-media__image', className].filter(Boolean).join(' ');

    return `
      <img
        src="${escapeHtml(src)}"
        alt="${escapeHtml(image.altText || fallbackAlt || '')}"
        ${srcset ? `srcset="${srcset}"` : ''}
        width="${width}"
        height="${height}"
        loading="${loading}"
        sizes="(min-width: 750px) 25.0vw, 100vw"
        class="${escapeHtml(imageClass)}"
        data_max_resolution="${escapeHtml(src)}"
        fetchpriority="auto"
        style="--focal-point: 50.0% 50.0%;"
      >
    `;
  }

  #renderProductPrice(product) {
    const selectedVariant = getFirstAvailableVariant(product);
    const saleVariant = selectedVariant && moneyGreaterThan(selectedVariant.compareAtPrice, selectedVariant.price)
      ? selectedVariant
      : getSaleVariant(product);
    const price = selectedVariant?.price || product.priceRange?.minVariantPrice;

    if (!saleVariant) {
      return `
        <div ref="priceContainer">
          <div class="price__regular">
            <span class="price">${escapeHtml(this.#formatProductPrice(product, price))}</span>
          </div>
          <div class="price__sale price__hidden"></div>
        </div>
      `;
    }

    return `
      <div ref="priceContainer">
        <div class="price__regular price__hidden">
          <span class="price">${escapeHtml(this.#formatProductPrice(product, saleVariant.price))}</span>
        </div>
        <div class="price__sale">
          <span class="price-item__group">
            <span class="visually-hidden">Sale price&nbsp;</span>
            <span class="price-item--sale price">${escapeHtml(this.#formatMoney(saleVariant.price))}</span>
          </span>
          <span class="price-item__group">
            <span class="visually-hidden">Regular price&nbsp;</span>
            <span class="price-item--regular compare-at-price">${escapeHtml(this.#formatMoney(saleVariant.compareAtPrice))}</span>
          </span>
        </div>
      </div>
    `;
  }

  #formatProductPrice(product, preferredPrice) {
    const min = preferredPrice || product.priceRange?.minVariantPrice;
    const max = product.priceRange?.maxVariantPrice;
    if (!min) return '';

    const minAmount = Number(min.amount || 0);
    const maxAmount = Number(max?.amount || min.amount || 0);
    const formattedMin = this.#formatMoney(min);

    if (!Number.isFinite(maxAmount) || maxAmount === minAmount) {
      return formattedMin;
    }

    return `From ${formattedMin}`;
  }

  #formatMoney(money) {
    if (!money) return '';

    const amount = typeof money.amount === 'string' ? Number(money.amount) : Number(money);
    const currency = money.currencyCode || 'AUD';

    return new Intl.NumberFormat(this.config.locale, {
      style: 'currency',
      currency,
    }).format(amount);
  }

  #imageUrl(url, width) {
    try {
      const nextUrl = new URL(url);
      nextUrl.searchParams.set('width', String(width));
      return nextUrl.toString();
    } catch (_error) {
      return url;
    }
  }

  #imageRatio(image) {
    const width = Number(image?.width || 1);
    const height = Number(image?.height || 1);

    if (!Number.isFinite(width) || !Number.isFinite(height) || height <= 0) {
      return '1.0';
    }

    return (width / height).toFixed(3);
  }

  #safeId(value) {
    return String(value || '')
      .replace(/^gid:\/\/shopify\//, '')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      || 'product';
  }
}

if (!customElements.get('partner-storefront')) {
  customElements.define('partner-storefront', PartnerStorefront);
}

if (!customElements.get('partner-product-list-carousel')) {
  customElements.define('partner-product-list-carousel', PartnerProductListCarousel);
}
